import { Married } from "./v1";

export const marriedOptions = Object.entries(Married)
	.filter(([value]) => {
		return isNaN(Number(value));
	})
	.map(([value, label]) => {
		return { value, label };
	});
